export type ForensicEntityType =
  | 'CHAT'
  | 'EMAIL'
  | 'NIK'
  | 'MSISDN'
  | 'PHONE'
  | 'DOMAIN'
  | 'URL'
  | 'NAME'
  | 'USERNAME'
  | 'IP'
  | 'IMEI'
  | 'IMSI'
  | 'PASSPORT'
  | 'CREDIT_CARD'
  | 'BTC_ADDRESS'
  | 'ETH_ADDRESS'
  | 'IBAN'
  | 'PERSON';

export interface ForensicPeer {
  id: string;
  type: 'user' | 'chat' | 'channel' | 'unknown';
  title: string;
  username?: string;
  phone?: string;
  bio?: string;
  photoId?: string;
  updatedAt: number;
}

export interface ForensicPeerHistory {
  id: number;
  peerId: string;
  field: string;
  oldValue?: string;
  newValue?: string;
  recordedAt: number;
}

export interface ForensicMessage {
  id: string;
  chatId: string;
  messageId: number;
  senderId?: string;
  date: number;
  text?: string;
  isDeleted?: boolean;
  isEdited?: boolean;
  ingestedAt: number;
}

export interface ForensicEntity {
  id: string;
  type: ForensicEntityType;
  value: string;
  normalized: string;
}

export interface ForensicEntityLink {
  id: number;
  entityId: string;
  chatId: string;
  messageId: number;
  context?: string;
}

export interface ForensicMedia {
  id: string;
  chatId: string;
  messageId: number;
  mimeType?: string;
  fileName?: string;
  size?: number;
  sha256?: string;
  url?: string;
}

export interface ForensicGraphNode {
  id: string;
  label: string;
  type: ForensicEntityType | 'PEER';
  size: number;
}

export interface ForensicGraphEdge {
  source: string;
  target: string;
  weight: number;
}

export interface ForensicGraph {
  nodes: ForensicGraphNode[];
  edges: ForensicGraphEdge[];
}

export interface ForensicStats {
  peerCount: number;
  messageCount: number;
  entityCount: number;
  linkCount: number;
  mediaCount: number;
  historyCount: number;
  byEntityType: Partial<Record<ForensicEntityType, number>>;
  topChats: { chatId: string; title: string; count: number }[];
}

export interface ForensicDatabase {
  version: number;
  peers: Record<string, ForensicPeer>;
  messages: Record<string, ForensicMessage>;
  entities: Record<string, ForensicEntity>;
  entityLinks: ForensicEntityLink[];
  peerHistory: ForensicPeerHistory[];
  media: Record<string, ForensicMedia>;
  config: Record<string, string>;
  nextLinkId: number;
  nextHistoryId: number;
}

export const EMPTY_FORENSIC_DB: ForensicDatabase = {
  version: 1,
  peers: {},
  messages: {},
  entities: {},
  entityLinks: [],
  peerHistory: [],
  media: {},
  config: {},
  nextLinkId: 1,
  nextHistoryId: 1,
};
